<template>
    <div class="company-tag">
        <div class="company-wrap">
            <van-icon name="arrow-down" v-if="!isopen" @click="open"/>
            <div class="company-box" v-show="!isopen">
                <a @click="selectTag(i)" :class="curTags.includes(i.enterpriseId) ? 'cur' : ''" class="company-tag"
                   v-for="i in companyList" v-if="i.positionCount > 0">{{i.enterpriseName}}({{i.positionCount}})</a>
            </div>

            <div class="slide-down" v-if="isopen">
                <div class="top-nav">
                    全部
                    <van-icon name="arrow-up" @click="close"/>
                </div>
                <a @click="selectTag(i, true)" class="company-tag"
                   :class="curTags.includes(i.enterpriseId) ? 'cur' : ''" v-for="i in companyList"
                   v-if="i.positionCount > 0">{{i.enterpriseName}}({{i.positionCount}})</a>
            </div>
        </div>
    </div>
</template>

<script>

  export default {
    name: "companyTag",
    components: {},
    props: {
      max: {
        default: 1
      },
      companyList: {}
    },
    data() {
      return {
        isopen: false,
        curTags: [~~this.$route.query.enterpriseId]
      };
    },
    methods: {
      open() {
        this.isopen = true;
      },
      close() {
        this.isopen = false;
      },
      selectTag(item, tag) {


        let distance = "";
        let dom = "";
        this.companyList.forEach((cp, index) => {
          if (item.enterpriseId == cp.enterpriseId) {
            dom = document.querySelector(".company-box").querySelectorAll("a")[index];
          }
        });

        let offsetLeft = dom.offsetLeft - 15,
          wd = dom.getBoundingClientRect().width,
          screen = document.body.offsetWidth - 60,
          scroll = document.querySelector(".company-box").scrollLeft;

        if (offsetLeft < scroll) {
          distance = offsetLeft - screen / 2 > 0 ? offsetLeft - screen / 2 : 0;
        } else if ((scroll + screen) < (offsetLeft + wd)) {
          distance = offsetLeft - screen / 2 + scroll;
        }

        if (this.max == 1) {
          if (this.curTags.includes(item.enterpriseId)) {
            this.curTags = [];
          } else {
            this.curTags = [item.enterpriseId];
            setTimeout(() => {
              document.querySelector(".company-box").scrollLeft = distance;
            });
          }
        } else {
          if (this.curTags.includes(item.enterpriseId)) {
            this.curTags = this.curTags.filter(cur => cur != item.enterpriseId);
          } else if (!this.curTags.includes(item.enterpriseId) && this.curTags.length < this.max) {
            this.curTags.push(item.enterpriseId);
            setTimeout(() => {
              document.querySelector(".company-box").scrollLeft = distance;
            });
          }
        }

        if (tag)
          this.isopen = false;

        let params = { ...this.$route.query };
        if (this.curTags && this.curTags.length) {
          params.enterpriseId = this.curTags.join(",");
        } else {
          delete params.enterpriseId;
        }
        this.$router.replace({ query: params });
      }
    },
    mounted() {

    },
    created() {
      console.log(this.curTags,'<<<<<<<<')
    }
  };
</script>

<style lang="scss" scoped>
    .company-wrap {
        padding: 10px 45px 10px 15px;
        background-color: #fff;
        position: relative;

        .cur {
            border: 0.5px solid #22BAA5 !important;
            color: #22BAA5 !important;
            background: #fff !important;
        }

        .van-icon {
            position: absolute;
            right: 15px;
            background: #fff;
            height: 30px;
            line-height: 30px;
            padding: 0 8px;
        }

        .company-box::-webkit-scrollbar {
            display: none;
        }

        .company-box {
            display: flex;
            overflow-y: hidden;
            width: 100%;
            overflow-x: scroll;

            .company-tag {
                background-color: #f5f5f5;
                border-radius: 4px;
                line-height: 28px;
                color: #666;
                padding: 0 10px;
                white-space: nowrap;
                margin-right: 10px;
                border: 0.5px solid #f5f5f5;
            }
        }

        .slide-down {
            width: 100%;
            position: absolute;
            min-height: 100px;
            padding: 15px;
            padding-top: 0;
            top: 0px;
            left: 0;
            background: #fff;
            z-index: 99;

            a {
                background-color: #f5f5f5;
                border-radius: 4px;
                line-height: 28px;
                color: #666;
                padding: 0 10px;
                margin-right: 10px;
                display: inline-block;
                margin-top: 10px;
                border: 0.5px solid #f5f5f5;
            }

            .top-nav {
                color: #323233;
                font-size: 14px;
                line-height: 24px;
                border-bottom: 0.5px solid #dddd;
                padding: 10px 0;
                i {
                    line-height: 24px;
                }
            }
        }
    }
</style>
